import {Attestation} from "../../common/attestsation";

export type InitialState = {
    attestations: Record<Attestation['id'], Attestation>,
    statistic: any[];
};
export const enum ACTION_TYPES {
    GET_ATTESTATIONS = 'getAttestations',
    GET_ATTESTATIONS_SUCCESS = 'getAttestationsSuccess',
    GET_ATTESTATION_SUBMISSION = 'getAttestationSubmition',
    GET_ATTESTATION_SUBMISSION_SUCCESS = 'getAttestationSubmitionSuccess',
    SEND_ATTESTATION_RESULTS = 'sendAttestationResults',
    GET_ATTESTATION_STATISTIC = 'getAttestationStatistic',
    GET_ATTESTATION_STATISTIC_SUCESS = 'getAttestationStatisticSuccess',
};

export type AttestationPayload = any;

export type Actions = {
    type: ACTION_TYPES,
    payload?: AttestationPayload,
};